require('./submit-readings');
require('./submit-multiple-readings');
require('./reading-validation');
require('./reading-photos');
require('./readings-import');
require('./day-prices');

/**
 * Highlight the section the URL hash points at.
 *
 * Runs on load and again on every hash change: a link to #theme-settings from
 * the settings page itself is a same-document navigation, so without the
 * listener the class would only ever be set on a fresh load.
 */
function highlightHashTarget() {
    let hash = window.location.hash.substring(1);

    $('.hash-selected').removeClass('hash-selected');

    if (! hash) {
        return;
    }

    let target = document.getElementById(hash);

    if (! target) {
        return;
    }

    target.classList.add('hash-selected');
    // scroll-margin-top on the target keeps it clear of a fixed header
    target.scrollIntoView();
}

window.addEventListener('hashchange', highlightHashTarget);

document.addEventListener('DOMContentLoaded', function () {
    highlightHashTarget();

    // get the estimated costs when table tab is clicked
    $('.costs input#elec_table, .costs input#gas_table').on('click', function (event) {
        // advance data already loaded earlier?
        if (typeof advance_calculated !== 'undefined' && advance_calculated) {
            return;
        }

        // for now, we don't want to load the future prices when clicking the tab
        return;

        // The logic below is intentionally kept for future use.
        // event.stopPropagation();
        // const params = new URLSearchParams(window.location.search);
        // const target = event.target;
        //
        // if (((target.id === 'elec_table') || (target.id === 'gas_table')) && (params.get('future') !== '1')) {
        //     hash = (target.id === 'elec_table') ? 'elec_anchor' : 'gas_anchor';
        //
        //     params.set('future', '1');
        //     params.set('future_analysis', '1');
        //
        //     window.location.href = `${location.protocol}//${location.host}${location.pathname}?${params.toString()}${hash ? '#' + hash : ''}`;
        // }
    });

    $('.segmented-control-tabs .segment').on('click', function () {
        const $segment = $(this);
        $segment.siblings().removeClass('active');
        $segment.addClass('active');

        if ($segment.data('tab') === 'gas') {
            $('.cheapest-moment').hide();
        } else {
            $('.cheapest-moment').show();
        }
    });

    // open the same tab on the other product
    $('#usage .tabset input[type=radio], #costs .tabset input[type=radio]').on('click', function (event) {
        const target = event.target;
        const id = target.id;

        // prevent click loop
        if (Object.prototype.hasOwnProperty.call(event, 'originalEvent')) {
            if (id.includes('elec')) {
                $('#' + id.replace('elec', 'gas')).click();
            } else if (id.includes('gas')) {
                $('#' + id.replace('gas', 'elec')).click();
            }
        }
    });

    // open the day table when goto button was clicked
    $('#goto_electricity_daily_table, #goto_gas_daily_table').on('click', function (event) {
        const target = event.target;

        if (target.id === 'goto_gas_daily_table') {
            $('#gas_day_table').click();
        } else if (target.id === 'goto_electricity_daily_table') {
            $('#elec_day_table').click();
        }
    });

    /**
     * Slide the standard yearly usage (SJV/SJP) columns of a month table open
     * or closed. The cells are animated on their width; the accompanying
     * .month-table-sjv-anim class lifts the intrinsic content width (via the
     * max-width:0 table-cell trick), so the animated width fully drives the
     * column size. Row heights are held by the always-visible columns, which
     * makes this render as a purely horizontal slide.
     *
     * @param {jQuery} $section - the tab panel holding the month table
     * @param {boolean} show - true to reveal the columns, false to collapse
     * @returns {void}
     */
    function animateSjvColumns($section, show) {
        const $cells = $section.find('.month-table-sjv').stop(true, true);

        if (show) {
            // Reveal the cells first so their natural width can be measured;
            // this happens in the same tick, so the full-width state is never
            // painted.
            $section.addClass('show-sjv');
            const widths = $cells.map(function () {
                return $(this).outerWidth();
            }).get();

            $cells.addClass('month-table-sjv-anim').each(function (index) {
                $(this).css({width: 0, minWidth: 0}).animate({width: widths[index]}, 300);
            });
        } else {
            $cells.addClass('month-table-sjv-anim').each(function () {
                $(this).css({width: $(this).outerWidth(), minWidth: 0}).animate({width: 0}, 300);
            });
        }

        // Drop the helper class and the inline widths only once every cell has
        // finished, so the columns end up back under stylesheet control.
        $cells.promise().done(function () {
            $cells.removeClass('month-table-sjv-anim').css({width: '', minWidth: ''});

            if (! show) {
                $section.removeClass('show-sjv');
            }
        });
    }

    // Toggle the standard yearly usage (SJV/SJP) columns in the month tables.
    // The choice is stored in a cookie so the next page render (year change,
    // other product, a fresh visit) can already output the columns as the
    // customer left them, without a flash of the collapsed table. Note: the
    // tab radio inputs reuse the same ids as the panels, hence the explicit
    // `section` selector.
    $(document).on('change', 'input.show-sjv-switch', function () {
        const section = (this.id === 'show_sjv_gas') ? 'gas_table' : 'elec_table';

        animateSjvColumns($('section#' + section), this.checked);
        setCookie(this.id, this.checked);
    });

    // open the same tab on the other product
    $('#day-prices .tabset input[type=radio]').on('click', function (event) {
        const target = event.target;
        const id = target.id;

        // prevent click loop
        if (Object.prototype.hasOwnProperty.call(event, 'originalEvent')) {
            if (id.includes('elec')) {
                $('#' + id.replace('elec', 'gas')).click();
            } else if (id.includes('gas')) {
                $('#' + id.replace('gas', 'elec')).click();
            }
        }
    });

    // show/hide admin info
    $('#admin-info-show').on('click', function () {
        $('#admin-info').toggle();
        const indicator = $('#admin-info-show-hide-indicator');
        const indicatorSign = indicator.html() === '+' ? '-' : '+';
        indicator.html(indicatorSign);
    });

    // show/hide admin ajax info
    $('#admin-ajax-show').on('click', function () {
        $('#admin-ajax').toggle();
        let indicator = $('#admin-ajax-show-hide-indicator');
        let indicatorSign = indicator.html();
        indicatorSign = indicatorSign === '+' ? '-' : '+';
        indicator.html(indicatorSign);
    });

    // show/hide admin drilldown info
    $('#admin-drilldown-show').on('click', function () {
        $('#admin-drilldown').toggle();
        let indicator = $('#admin-drilldown-show-hide-indicator');
        let indicatorSign = indicator.html();
        indicatorSign = indicatorSign === '+' ? '-' : '+';
        indicator.html(indicatorSign);
    });

    $('.segmented-control-tabs .segment').on('click', function () {
        // Remove active class from all segments
        $(this).siblings().removeClass('active');
        // Add active class to the clicked button
        $(this).addClass('active');

        // If the clicked tab is 'gas', hide the .cheapest-moment element
        if ($(this).data('tab') === 'gas') {
            $('.cheapest-moment').hide();
        } else {
            $('.cheapest-moment').show();
        }

        // Get the tab ID from the clicked button
        const tabId = $(this).data('tab');

        $(this).closest('.tabs-container').find('.tab-content').each(function () {
            $(this).toggleClass('active', this.id === 'tab-' + tabId);
        });
    });

    $('.segmented-control-tabs .segment.active').trigger('click')

    /**
     * Rebuild the href of every download button for one product based on the
     * current interval switch, start/end dates and readingType mapping.
     * Buttons with data-hide-for-interval stay hidden (e.g. PDF for kwartier).
     *
     * Handles both the usage/verbruik tab (.usage-download-actions with an
     * interval switch + readingType mapping) and the costs/kostenoverzicht tab
     * (.costs-download-actions with a month/dynamic mode switch). A page can
     * contain BOTH blocks for the same product (the kwiek downloads page), so
     * every actions container is synced on its own instead of treating the
     * whole set as one kind.
     *
     * @param {'electricity'|'gas'} product
     * @returns {void}
     */
    function syncDownloadButtons(product) {
        $('.usage-download-actions[data-product="' + product + '"]').each(function () {
            var $actions = $(this);

            if ($actions.hasClass('costs-download-actions')) {
                syncCostsDownloadButtons(product, $actions);
            } else {
                syncUsageDownloadButtons(product, $actions);
            }
        });
    }

    /**
     * Rebuild the button hrefs of one usage/verbruik download block from its
     * interval switch, date inputs and readingType mapping.
     *
     * @param {'electricity'|'gas'} product
     * @param {jQuery} $actions - the .usage-download-actions container
     * @returns {void}
     */
    function syncUsageDownloadButtons(product, $actions) {
        var baseUrl = $actions.data('base-url');
        var readingTypes = $actions.data('reading-types') || {};
        var interval = $('input[name="interval_' + product + '"]:checked').val()
            || $('input[name="interval_' + product + '"]').first().val()
            || 'day';
        var start = $('#download_start_' + product).val();
        var end = $('#download_end_' + product).val();

        // The "All data" quick-select has no fixed start/end: it asks the
        // backend for the full history (every KAS year / the first-last
        // MongoDB range). Without explicit dates we must fall back to the
        // named `period` so the controller knows it's an "all" request,
        // otherwise the export silently comes back empty.
        var period = $actions.data('selected-period');

        $actions.find('.usage-download-button').each(function () {
            var $btn = $(this);
            var format = $btn.data('format');
            var hideFor = $btn.data('hide-for-interval');

            // Some formats don't make sense for some intervals (e.g. PDF
            // would be unusable for the 35k+ rows in a year of kwartier
            // standen).
            if (hideFor && hideFor === interval) {
                $btn.hide();
                return;
            }
            $btn.show();

            var params = ['type=' + format];
            if (start) { params.push('start=' + encodeURIComponent(start)); }
            if (end)   { params.push('end='   + encodeURIComponent(end)); }

            // Only send `period` when we have no explicit date range; the
            // date inputs always win so manual edits keep working.
            if (! start && ! end && period) {
                params.push('period=' + encodeURIComponent(period));
            }

            var readingType = readingTypes[interval];
            if (readingType) {
                params.push('readingType=' + readingType);
            }

            $btn.attr('href', baseUrl + '?' + params.join('&'));
        });
    }

    /**
     * Rebuild the costs download button hrefs from the month/dynamic switch:
     * month uses the selected year, dynamic the date range. Toggles the year
     * row and date-range/quick-period row to match the active mode.
     *
     * @param {'electricity'|'gas'} product
     * @param {jQuery} $actions - the .costs-download-actions container
     * @returns {void}
     */
    function syncCostsDownloadButtons(product, $actions) {
        var baseUrl = $actions.data('base-url');
        var switchName = $actions.data('mode-switch');

        var mode = $('input[name="' + switchName + '"]:checked').val()
            || $('input[name="' + switchName + '"]').first().val()
            || 'month';

        var isDynamic = (mode === 'dynamic');

        var year = $('#costs_download_year_' + product).val() || $actions.data('year');

        // Show the year row for month, the date range/quick-periods for dynamic.
        var $block = $('#container_costs_download_' + (product === 'electricity' ? 'elec' : 'gas'));
        $block.find('.costs-download-year-row').toggle(! isDynamic);
        $block.find('.costs-download-daterange, .costs-download-quick-row').toggle(isDynamic);

        var start = $('#costs_download_start_' + product).val();
        var end = $('#costs_download_end_' + product).val();
        var period = $actions.data('selected-period');

        $actions.find('.usage-download-button').each(function () {
            var $btn = $(this);
            var format = $btn.data('format');
            var hideForMode = $btn.data('hide-for-mode');

            // Some formats don't make sense for some modes (e.g. PDF would be
            // unusable for the thousands of rows in a dynamic export).
            if (hideForMode && hideForMode === mode) {
                $btn.hide();
                return;
            }
            $btn.show();

            var params = ['type=' + format, 'mode=' + mode];

            if (isDynamic) {
                if (start) { params.push('start=' + encodeURIComponent(start)); }
                if (end)   { params.push('end='   + encodeURIComponent(end)); }
                if (! start && ! end && period) {
                    params.push('period=' + encodeURIComponent(period));
                }
            } else if (year) {
                params.push('year=' + encodeURIComponent(year));
            }

            $btn.attr('href', baseUrl + '?' + params.join('&'));
        });
    }

    // Quick-period buttons: fill in the date inputs and refresh the URLs. The
    // costs tab uses its own input ids (costs_download_*), so resolve the date
    // fields from the surrounding block rather than a fixed id.
    $(document).on('click', '.usage-download-quick-period', function () {
        var $btn = $(this);
        var product = $btn.data('product');
        var start = $btn.data('start') || '';
        var end = $btn.data('end') || '';

        var $block = $btn.closest('.usage-download-block');
        $block.find('.usage-download-date[data-product="' + product + '"]').each(function () {
            var id = this.id || '';
            if (id.indexOf('start') !== -1) {
                $(this).val(start);
            } else if (id.indexOf('end') !== -1) {
                $(this).val(end);
            }
        });

        // Remember which named period was chosen so syncDownloadButtons can
        // forward it to the backend when there's no explicit date range
        // (the "All data" case). Scoped to this block: the usage and costs
        // download blocks can share a page and must not affect each other.
        $block.find('.usage-download-actions[data-product="' + product + '"]')
            .data('selected-period', $btn.data('period') || '');

        // Show which preset is active; a manual date edit clears it again.
        $btn.siblings('.usage-download-quick-period').removeClass('is-active');
        $btn.addClass('is-active');

        syncDownloadButtons(product);
    });

    /**
     * Sync .is-checked styling on switch labels for one product. Fallback for
     * browsers without :has() support on the switch styling. Covers both the
     * usage interval switch and the costs month/dynamic switch.
     *
     * @param {'electricity'|'gas'} product
     * @returns {void}
     */
    function refreshIntervalSwitch(product) {
        // Mark the surrounding label so the styling can target older browsers
        // that don't support :has(). Always operate on the radios so the
        // unchecked siblings get their .is-checked class removed too.
        $('input[name="interval_' + product + '"], input[name="costs_mode_' + product + '"]').each(function () {
            $(this).closest('.usage-download-switch-option')
                   .toggleClass('is-checked', this.checked);
        });
    }

    // Recompute URLs whenever a switch (usage interval or costs mode) or a date
    // input changes.
    $(document).on('change', 'input[name^="interval_"], input[name^="costs_mode_"]', function () {
        var product = $(this).data('product');
        refreshIntervalSwitch(product);
        syncDownloadButtons(product);
    });
    $(document).on('change', '.usage-download-date', function () {
        var product = $(this).data('product');
        var $block = $(this).closest('.usage-download-block');

        // A manual date edit means the user is no longer on a named period;
        // drop the remembered "All data"/quick-period so we don't tack a
        // stale period onto the URL once the range is cleared again, and
        // clear the active-preset highlight for the same reason. Scoped to
        // this block so a sibling usage/costs block keeps its own period.
        $block.find('.usage-download-actions[data-product="' + product + '"]')
            .data('selected-period', '');
        $block.find('.usage-download-quick-period').removeClass('is-active');

        syncDownloadButtons(product);
    });

    // Initialise on page load so the default selection produces working URLs.
    $('.usage-download-actions').each(function () {
        var product = $(this).data('product');
        refreshIntervalSwitch(product);
        syncDownloadButtons(product);
    });
});
